export { Dropdown } from './dropdown';
export { Modal } from './modal';
export { NavGroup } from './nav-group';
export { Sidebar } from './sidebar';
export { Slider } from './slider';
export { Theme } from './theme';
export { Toast } from './toast';
export type { ToastOptions, ToastType, ToastPosition, ToastLink } from './toast';
export { StatusOverlay } from './status-overlay';
export { ReconnectOverlay, DEFAULT_RECONNECT_TEXTS } from './reconnect';
export type { ReconnectOptions, ReconnectTexts } from './reconnect';
export type {
  StatusOverlayOptions,
  StatusTone,
  StatusTheme,
  StatusLayout,
  StatusIndicator,
  StatusIconName,
  StatusAction,
} from './status-overlay';
export { Tooltip } from './tooltip';
export { Popover } from './popover';
export { DatePickerAnchor } from './datepicker';
export { DatePicker } from './datepicker-widget';
export type { PopoverOptions, PopoverTrigger } from './popover';
export type { ThemeValue } from './theme';
export { autoInit } from './auto-init';
export const VERSION = '2.0.0';

import { autoInit as _autoInit } from './auto-init';
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _autoInit);
  } else {
    _autoInit();
  }
}
